<template>
  <div class="grid cols-1 gap-4 my-16">
    <div class="w-64 place-self-center">
      <p class="h-6 text-base text-center">
        {{ trans.get('miliboo.filters.show') }} {{ to ?? 0 }}
        {{ trans.get('miliboo.filters.total-products') }}
        {{ lastPage.data.paginator.total }}
      </p>
      <div class="bg-gray-300 h-0.5 flex items-center">
        <span
          class="bg-gray-900 h-0.5"
          :style="`width: ${percent}%`"
        />
      </div>
    </div>
    <div
      v-if="lastPage.data.paginator.current_page < lastPage.data.paginator.last_page"
      class="place-self-center"
    >
      <VButtonOutlineAnimated
        :disabled="disabled"
        @click="$emit('click')"
      >
        {{ trans.get('miliboo.filters.show-more') }}
      </VButtonOutlineAnimated>
    </div>
  </div>
</template>

<script setup>
import { inject, computed } from 'vue';
import VButtonOutlineAnimated from '../buttons/VButtonOutlineAnimated.vue';

const props = defineProps({
  pages: {
    type: Array,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['click']);

const trans = inject('translate');

const lastPage = computed(() => props.pages[props.pages.length - 1]);
const to = computed(() => props.pages.reduce((partialSum, page) => partialSum + page.data.paginator.data.length, 0));
const percent = computed(() => (to.value * 100) / lastPage.value.data.paginator.total);

</script>
